const makeRequest = async (requestBody, endpoint) => {
	const URL = `https://appwebinteractivo-76vldchz.uc.gateway.dev/${endpoint}?key=AIzaSyDNY2_dPyPq7gWAPNUGoZEWynZrmStDsnc`;

	const requestOptions = {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
		},
		body: JSON.stringify(requestBody),
	};

	try {
		const response = await fetch(URL, requestOptions);
		const data = await response.json();
		return data.response;
	} catch (error) {
		console.log(error);
	}
};

const getCountries = (requestBody) => makeRequest(requestBody, "getcountries");
const getCountriesValues = (requestBody) => makeRequest(requestBody, "getcountriesvalues");

export {getCountries, getCountriesValues};
